import { CancelSubscriptionLinks } from 'constants/staticLinks'

import { LanguageCode } from 'translations/Language'

export const getCancelSubscriptionLink = (language: string) => {
  switch (language) {
    case LanguageCode.FR:
      return CancelSubscriptionLinks.FR
    case LanguageCode.DE:
      return CancelSubscriptionLinks.DE
    case LanguageCode.ES:
      return CancelSubscriptionLinks.ES
    case LanguageCode.NL:
      return CancelSubscriptionLinks.NL
    case LanguageCode.EN:
    default:
      return CancelSubscriptionLinks.EN
  }
}
